import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { constants } from '@pepconnect/constants';
import { ssoConstants } from '@pepconnect/features/sso/model/sso-constants';
import { SamlService } from '@pepconnect/features/sso/services/saml.service';
import { WINDOW } from '@pepconnect/providers/window-provider';
import { BaseV2SmartComponent } from '@pepconnect/shared/base/base-smart-component-v2';
import { first } from 'rxjs';

/**
 * This component provides Service Provider initiated Log out functionality with PEPconnect acting
 * as the service provider. A user can be directed here in order to send the LogoutRequest to the IdP
 * from PEPconnect, which will then redirect them to a LogoutResponse page with the IdP's response.
 */
@Component({
  selector: 'app-saml-sp-logout',
  standalone: false,
  template: ''
})
export class SamlSpLogoutComponent extends BaseV2SmartComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly samlService = inject(SamlService);
  private readonly window = inject(WINDOW);

  private providerId: string;
  private relayState: string;

  ngOnInit() {
    this.providerId = this.route.snapshot.paramMap.get('launchId');
    this.relayState = this.route.snapshot.queryParamMap.get('RelayState') ?? '';

    if (this.providerId) {
      // make sure we're initialized before we do anything
      this.authState$.pipe(
        first(s => s.isInitialized)
      ).subscribe({
        next: s => {
          // if we're logged in, then continue the logout request
          if (s.isLoggedIn) {
            this.processLogout();
          }
        }, error: () => {
          // oh noes! we're not logged in so we don't really care at this point
          this.router.navigate([this.authState.user.locale.locale, constants.REDIRECT_REQUIREMENT_ANONYMOUS]);
        }
      });
    } else {
      this.router.navigate(['404']);
    }
    
  }

  processLogout() {
    this.samlService.getLogoutRequest(this.providerId, this.relayState).subscribe({
      next: (request) => {
        // look to see what type of redirect binding we should be using
        if (request.bindingProtocol === ssoConstants.SAML_BINDING_POST) {
          // if it's post then we need to post the auth data to the endpoint
          this.samlService.postSamlAction(request);
        } else {
          // if we're doing a redirect everything is crammed into the URL and we just toss them over the fence
          this.window.location.href = request.destination;
        }
      },
      error: () => {
        // oh noes!
      }
    });
  }
}
